import { SensorGroupStateType } from './state'

export interface SensorGroupGettersType {
  getSensorGroupById: (state: SensorGroupStateType, id: string) => SensorGroupStateType['sensorGroup']
  getSensorGroupByName: (state: SensorGroupStateType, name: string) => SensorGroupStateType['sensorGroup']
  getSensorGroupsByCreatedBy: (state: SensorGroupStateType, createdBy: string) => SensorGroupStateType['sensorGroups']
}

export const SensorGroupGetters = {
  getSensorGroupById: (state: SensorGroupStateType) => (id: string) => {
    return state.sensorGroups.find(sensorGroup => sensorGroup.id === id)
  },
  getSensorGroupByName: (state: SensorGroupStateType) => (name: string) => {
    return state.sensorGroups.find(sensorGroup => sensorGroup.name === name)
  },
  getSensorGroupsByCreatedBy: (state: SensorGroupStateType) => (createdBy: string) => {
    return state.sensorGroups.filter(sensorGroup => sensorGroup.createdBy === createdBy)
  },
}
